export default __webpack_public_path__ + "static/media/mfp.ba2d42b5.png";